import classNames from 'classnames';
import { RoadmapForm } from '@sapientpro/sapientpro-data-models';
import styles from './SurveySection.module.scss';
import Button, { ButtonVariants } from '../Button';
import Img from '../Img';

export type TEntityItem = RoadmapForm['defaultList'][number];
export type TEntityItemData = TEntityItem['service'];

const EntityItem = ({ item }: { item: TEntityItem | TEntityItemData }) => {
  const data = (item as TEntityItem).service || (item as TEntityItem).subservice;
  const entity = data || (item as TEntityItemData);
  const title = entity?.title?.split('**').join('') || '';

  const isCase = (entity as any)?.type === 'case';
  const linkPrefix = isCase ? 'cases/' : '/';
  const link = `${linkPrefix}${entity?.slug}`;
  const buttonText = isCase ? 'View Case' : 'View Service';

  const description = entity?.previewDescription || entity?.description;

  return (
    <article className={styles.entryItem}>
      <p className={classNames(styles.label, 'tag')}>Recommended</p>
      <div className={styles.content}>
        <div className={styles.text}>
          <p className={classNames(styles.title, 'header4')}>{title}</p>
          <div
            dangerouslySetInnerHTML={{ __html: description || '' }}
            className={classNames(styles.description, 'bodySmall')}
          />
        </div>

        {!!entity?.previewImage && (
        <Img
          src={entity?.previewImage.url}
          height={entity?.previewImage.height}
          width={entity?.previewImage.width}
          alt={entity?.previewImage.alternativeText || 'image'}
          className={styles.itemImage}
        />
        )}
      </div>

      <Button
        variant={ButtonVariants.TRANSPARENT}
        iconPosition='right'
        className={styles.itemLink}
        icon={(
          <svg className={styles.itemIcon}>
            <use
              xlinkHref='/media/icon-nest.svg#iconNest'
              href='/media/icon-nest.svg#iconNest'
            />
          </svg>
        )}
        link={link}
      >
        {buttonText}
      </Button>
    </article>
  );
};

export default EntityItem;
